import {
  white,
  blueMain,
  drawerListTextColor,
  drawerListHoverColor,
  blackMain,
  navbarDivider,
  blackMainLightHover,
} from '../../../theme';
const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: 'flex',
  },
  list: {
    paddingTop: 0,
  },
  toolBar: {
    '&.MuiToolbar-gutters': {
      paddingLeft: '12px',
    },
    '& .MuiIconButton-label': {
      fontSize: '20px',
    },
  },
  menuButton: {
    '&:hover': {
      backgroundColor: blackMainLightHover,
    },
    marginRight: 0,
    width: '50px',
    height: '50px',
    minHeight: '50px',
    borderRadius: 0,
    borderRight: `1px solid ${navbarDivider}`,
    color: white,
  },
  drawer: {
    flexShrink: 0,
  },
  drawerPaper: {
    padding: '1rem 0 0',
    top: '50px',
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  active: {
    color: `${blackMain} !important`,
    backgroundColor: `${drawerListHoverColor} !important`,
    '&:before': {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      width: '4px',
      backgroundColor: `${blueMain}`,
      content: '""',
    },
  },
  otherTools: {
    marginTop: '8px !important',
  },
  tool: {
    paddingLeft: '2.5rem',
    '& .MuiTypography-body1': {
      fontWeight: '400 !important',
    },
  },
  listItem: {
    color: drawerListTextColor,
    backgroundColor: 'transparent',
    '&:hover': {
      color: blackMain,
      backgroundColor: drawerListHoverColor,
    },
    '& .MuiSvgIcon-root': {
      transition: 'transform 110ms,fill 110ms,-webkit-transform 110ms',
    },
    '&.MuiListItem-root': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  listItemText: {
    '& .MuiTypography-body1': {
      fontWeight: 600,
      fontSize: '14px',
    },
  },
  deleteBorder: {
    border: 'none',
  },
});

export default styles;
